export default "__VITE_ASSET__Df6AaBFy__"